"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        meta: {
            homeTitle: "Vos Sumás — Panda Net SRL",
            homeDescription: "Vos Sumás turns education, sports, culture, social commitment, and community participation into medals and benefits, connecting young people, municipalities, institutions, and local businesses.",
            privacyTitle: "Privacy Policy — Vos Sumás",
            privacyDescription: "Privacy Policy and personal data processing for Vos Sumás, operated by Panda Net SRL.",
            termsTitle: "Terms & Conditions — Vos Sumás",
            termsDescription: "Terms and Conditions of use for the Vos Sumás mobile application, operated by Panda Net SRL.",
        },
        nav: {
            howItWorks: "How it works",
            earn: "What earns medals",
            medals: "Medals",
            redeem: "Redeem",
            join: "Join",
            municipalities: "Municipalities",
            company: "Company",
            contact: "Contact",
            openMenu: "Open menu",
            closeMenu: "Close menu",
        },
        hero: {
            brand: "Vos Sumás",
            title: "Your effort is worth more.",
            subtitle: "Vos Sumás is the app that turns what you do every day into medals you can use in your city.",
            ctaGooglePlay: "Download on Google Play",
            ctaAppStore: "Download on the App Store",
            availableSoon: "Available soon",
        },
        howItWorks: {
            title: "The idea is simple",
            step1Title: "You do something.",
            step1Body: "Sports, studying, art, helping others…",
            step2Title: "You earn medals.",
            step2Body: "Virtual, unique, and earned by you.",
            step3Title: "You use your QR.",
            step3Body: "Redeem it at participating businesses and events.",
            step4Title: "You get recognized.",
            step4Body: "Your achievements are visible in your community.",
        },
        earn: {
            title: "What can you earn medals for?",
            subtitle: "Whatever your passion is, there are medals here for you.",
            educationTitle: "Education",
            educationBody: "Outstanding grades, attendance, extracurricular courses.",
            sportsTitle: "Sports",
            sportsBody: "Sports at municipal facilities, tournaments, active recreation.",
            socialTitle: "Social commitment",
            socialBody: "Supporting older adults, volunteering, environmental care.",
            environmentTitle: "Environment",
            environmentBody: "Recycling, cleanup events, environmental awareness.",
            artTitle: "Art and culture",
            artBody: "Municipal workshops, classes, community arts activities.",
            civicTitle: "Civic technology",
            civicBody: "Collaboration on the municipality’s social media channels and promotion of municipal programs.",
        },
        medals: {
            title: "Medals",
            subtitle: "Every month brings new challenges. Special medals are for those who go one step further.",
            laurusName: "LAURUS",
            laurusBody: "For merit and effort: culture, workshops, consistency.",
            featured: "Featured medal",
        },
        redeem: {
            title: "How do you use your medals?",
            body: "In the app, users open the Redeem section, choose a category such as dining, sports, or entertainment, browse nearby participating businesses, select a benefit, see how many medals are required, and generate a single-use QR code to present at the business. The complete redemption history is available under “My Redemptions.”",
            flow1: "Open Redeem",
            flow2: "Choose a category",
            flow3: "Pick a benefit",
            flow4: "Generate your QR",
            catsTitle: "Redemption categories",
            shows: "Shows",
            entertainment: "Entertainment",
            dining: "Dining",
            supermarkets: "Supermarkets",
            sports: "Sports",
            transportation: "Transportation",
        },
        join: {
            title: "Joining is easy",
            step1Title: "Download the app.",
            step1Body: "Google Play or App Store. It’s free.",
            step2Title: "Enter your phone number.",
            step2Body: "Area code without the leading zero + phone number.",
            step3Title: "Verify with your DNI.",
            step3Body: "The system securely verifies your identity.",
            step4Title: "Start earning!",
            step4Body: "Your first medal arrives automatically. You earn the rest.",
        },
        municipalities: {
            title: "The youth merit platform for innovative municipalities.",
            intro: "Vos Sumás is a smart public-policy platform that connects young people, institutions, and businesses.",
            b1: "Young people connected to the municipality, with a permanent presence on the device they use most.",
            b2: "Real-time strategic data for better public-policy decisions.",
            b3: "Formal public-private partnerships with businesses and institutions.",
            b4: "Improved social indicators across health, education, sports, and the environment.",
            b5: "Recognition of youth merit that is visible and valued by the community.",
            b6: "Positioning as a modern and innovative municipality.",
            cta: "Your municipality can be the next to turn merit into public policy. Contact us for a personalized presentation.",
            ctaButton: "Contact us",
        },
        company: {
            title: "Company",
            body: "Vos Sumás is a platform developed and operated by Panda Net SRL, an Argentine company based in the City of Buenos Aires. Panda Net SRL is responsible for the development, operation, and support of Vos Sumás. For commercial or institutional inquiries, contact us at administracion@vossumas.com.",
            entityType: "Entity type",
            legalName: "Legal name",
            cuit: "CUIT",
        },
        contact: {
            title: "Contact",
            intro: "Reach Panda Net SRL for commercial, institutional, or general inquiries about Vos Sumás.",
            administracionLabel: "Commercial / institutional",
            contactoLabel: "General contact",
            infoLabel: "Information",
            waitlistTitle: "Get notified when the apps launch",
            waitlistBody: "Optional. Leave your email and we will let you know when downloads are available.",
            emailPlaceholder: "your@email.com",
            submitButton: "Notify me",
            sendingButton: "Sending...",
            privacyNote: "We will only use your email for launch updates. You can unsubscribe anytime.",
            availableSoonTitle: "Apps available soon",
            availableSoonBody: "Store links will appear here as soon as Vos Sumás is published on Google Play and the App Store.",
        },
        form: {
            invalidEmail: "Invalid email",
            invalidEmailDescription: "Please enter a valid email address.",
            thankYou: "Thank you!",
            successMessage: "Message sent successfully.",
            couldNotSend: "We couldn't send your request",
            emailRequired: "Email required.",
            somethingWentWrong: "Oops, something went wrong",
            tryAgain: "Try again in a few seconds.",
        },
        footer: {
            legalLine: "© 2026 Panda Net SRL. All rights reserved. Vos Sumás is a brand of Panda Net SRL.",
            privacy: "Privacy Policy",
            terms: "Terms & Conditions",
            contact: "Contact",
        },
        legalPage: {
            downloadPdf: "Download PDF",
            backHome: "Back to home",
            spanishOnlyNote: "This legal document is published in Spanish, as approved by the client.",
        },
        common: {
            close: "Close",
        },
    },
    es: {
        meta: {
            homeTitle: "Vos Sumás — Panda Net SRL",
            homeDescription: "Vos Sumás convierte educación, deporte, cultura, compromiso social y participación comunitaria en medallas y beneficios, conectando jóvenes, municipios, instituciones y comercios locales.",
            privacyTitle: "Política de Privacidad — Vos Sumás",
            privacyDescription: "Política de Privacidad y tratamiento de datos personales de Vos Sumás, operada por Panda Net SRL.",
            termsTitle: "Términos y Condiciones — Vos Sumás",
            termsDescription: "Términos y Condiciones de uso de la aplicación móvil Vos Sumás, operada por Panda Net SRL.",
        },
        nav: {
            howItWorks: "Cómo funciona",
            earn: "Qué otorga medallas",
            medals: "Medallas",
            redeem: "Canje",
            join: "Sumate",
            municipalities: "Municipios",
            company: "Empresa",
            contact: "Contacto",
            openMenu: "Abrir menú",
            closeMenu: "Cerrar menú",
        },
        hero: {
            brand: "Vos Sumás",
            title: "Tu esfuerzo vale más.",
            subtitle: "Vos Sumás es la app que convierte lo que hacés todos los días en medallas que podés usar en tu ciudad.",
            ctaGooglePlay: "Descargar en Google Play",
            ctaAppStore: "Descargar en App Store",
            availableSoon: "Disponible pronto",
        },
        howItWorks: {
            title: "La idea es simple",
            step1Title: "Hacés algo.",
            step1Body: "Deporte, estudio, arte, ayudar a otros…",
            step2Title: "Ganás medallas.",
            step2Body: "Virtuales, únicas y ganadas por vos.",
            step3Title: "Usás tu QR.",
            step3Body: "Canjealo en comercios y eventos participantes.",
            step4Title: "Te reconocen.",
            step4Body: "Tus logros son visibles en tu comunidad.",
        },
        earn: {
            title: "¿Por qué podés ganar medallas?",
            subtitle: "Sea cual sea tu pasión, acá hay medallas para vos.",
            educationTitle: "Educación",
            educationBody: "Buenas notas, asistencia, cursos extracurriculares.",
            sportsTitle: "Deporte",
            sportsBody: "Deporte en instalaciones municipales, torneos, recreación activa.",
            socialTitle: "Compromiso social",
            socialBody: "Acompañamiento a adultos mayores, voluntariado, cuidado ambiental.",
            environmentTitle: "Ambiente",
            environmentBody: "Reciclaje, jornadas de limpieza, concientización ambiental.",
            artTitle: "Arte y cultura",
            artBody: "Talleres municipales, clases, actividades artísticas comunitarias.",
            civicTitle: "Tecnología cívica",
            civicBody: "Colaboración en los canales de redes del municipio y promoción de programas municipales.",
        },
        medals: {
            title: "Medallas",
            subtitle: "Cada mes trae nuevos desafíos. Las medallas especiales son para quienes van un paso más allá.",
            laurusName: "LAURUS",
            laurusBody: "Por mérito y esfuerzo: cultura, talleres, constancia.",
            featured: "Medalla destacada",
        },
        redeem: {
            title: "¿Cómo usás tus medallas?",
            body: "En la app, abrís la sección Canjear, elegís una categoría como gastronomía, deporte o entretenimiento, explorás comercios participantes cercanos, seleccionás un beneficio, ves cuántas medallas se requieren y generás un código QR de un solo uso para presentar en el comercio. El historial completo está en “Mis canjes”.",
            flow1: "Abrí Canjear",
            flow2: "Elegí una categoría",
            flow3: "Elegí un beneficio",
            flow4: "Generá tu QR",
            catsTitle: "Categorías de canje",
            shows: "Espectáculos",
            entertainment: "Entretenimiento",
            dining: "Gastronomía",
            supermarkets: "Supermercados",
            sports: "Deporte",
            transportation: "Transporte",
        },
        join: {
            title: "Sumarte es fácil",
            step1Title: "Descargá la app.",
            step1Body: "Google Play o App Store. Es gratis.",
            step2Title: "Ingresá tu teléfono.",
            step2Body: "Código de área sin el cero inicial + número.",
            step3Title: "Verificá con tu DNI.",
            step3Body: "El sistema verifica tu identidad de forma segura.",
            step4Title: "¡Empezá a sumar!",
            step4Body: "Tu primera medalla llega sola. El resto las ganás vos.",
        },
        municipalities: {
            title: "La plataforma de mérito juvenil para municipios innovadores.",
            intro: "Vos Sumás es una plataforma de política pública inteligente que conecta jóvenes, instituciones y comercios.",
            b1: "Jóvenes conectados con el municipio, con presencia permanente en el dispositivo que más usan.",
            b2: "Datos estratégicos en tiempo real para mejores decisiones de política pública.",
            b3: "Alianzas público-privadas formales con comercios e instituciones.",
            b4: "Mejora de indicadores sociales en salud, educación, deporte y ambiente.",
            b5: "Reconocimiento del mérito juvenil visible y valorado por la comunidad.",
            b6: "Posicionamiento como municipio moderno e innovador.",
            cta: "Tu municipio puede ser el próximo en convertir el mérito en política pública. Contactanos para una presentación personalizada.",
            ctaButton: "Contactanos",
        },
        company: {
            title: "Empresa",
            body: "Vos Sumás es una plataforma desarrollada y operada por Panda Net SRL, una empresa argentina con sede en la Ciudad de Buenos Aires. Panda Net SRL es responsable del desarrollo, la operación y el soporte de Vos Sumás. Para consultas comerciales o institucionales, escribinos a administracion@vossumas.com.",
            entityType: "Tipo de entidad",
            legalName: "Razón social",
            cuit: "CUIT",
        },
        contact: {
            title: "Contacto",
            intro: "Contactá a Panda Net SRL para consultas comerciales, institucionales o generales sobre Vos Sumás.",
            administracionLabel: "Comercial / institucional",
            contactoLabel: "Contacto general",
            infoLabel: "Información",
            waitlistTitle: "Avisame cuando salgan las apps",
            waitlistBody: "Opcional. Dejanos tu email y te avisamos cuando las descargas estén disponibles.",
            emailPlaceholder: "tu@email.com",
            submitButton: "Avisame",
            sendingButton: "Enviando...",
            privacyNote: "Solo usaremos tu email para novedades de lanzamiento. Podés darte de baja cuando quieras.",
            availableSoonTitle: "Apps disponibles pronto",
            availableSoonBody: "Los enlaces a las tiendas aparecerán aquí cuando Vos Sumás se publique en Google Play y App Store.",
        },
        form: {
            invalidEmail: "Email inválido",
            invalidEmailDescription: "Por favor ingresá un email válido.",
            thankYou: "¡Gracias!",
            successMessage: "Mensaje enviado correctamente.",
            couldNotSend: "No pudimos enviar tu solicitud",
            emailRequired: "Email requerido.",
            somethingWentWrong: "Ups, algo salió mal",
            tryAgain: "Intentá de nuevo en unos segundos.",
        },
        footer: {
            legalLine: "© 2026 Panda Net SRL. Todos los derechos reservados. Vos Sumás es una marca de Panda Net SRL.",
            privacy: "Política de Privacidad",
            terms: "Términos y Condiciones",
            contact: "Contacto",
        },
        legalPage: {
            downloadPdf: "Descargar PDF",
            backHome: "Volver al inicio",
            spanishOnlyNote: "Este documento legal se publica en español, según el texto aprobado por el cliente.",
        },
        common: {
            close: "Cerrar",
        },
    },
    fr: {
        meta: {
            homeTitle: "Vos Sumás — Panda Net SRL",
            homeDescription: "Vos Sumás turns education, sports, culture, social commitment, and community participation into medals and benefits, connecting young people, municipalities, institutions, and local businesses.",
            privacyTitle: "Politique de confidentialité — Vos Sumás",
            privacyDescription: "Privacy Policy and personal data processing for Vos Sumás, operated by Panda Net SRL.",
            termsTitle: "Conditions générales — Vos Sumás",
            termsDescription: "Terms and Conditions of use for the Vos Sumás mobile application, operated by Panda Net SRL.",
        },
        nav: {
            howItWorks: "Comment ça marche",
            earn: "Gagner des médailles",
            medals: "Médailles",
            redeem: "Échanger",
            join: "Rejoindre",
            municipalities: "Municipalités",
            company: "Entreprise",
            contact: "Contact",
            openMenu: "Ouvrir le menu",
            closeMenu: "Fermer le menu",
        },
        hero: {
            brand: "Vos Sumás",
            title: "Your effort is worth more.",
            subtitle: "Vos Sumás is the app that turns what you do every day into medals you can use in your city.",
            ctaGooglePlay: "Download on Google Play",
            ctaAppStore: "Download on the App Store",
            availableSoon: "Bientôt disponible",
        },
        howItWorks: {
            title: "The idea is simple",
            step1Title: "You do something.",
            step1Body: "Sports, studying, art, helping others…",
            step2Title: "You earn medals.",
            step2Body: "Virtual, unique, and earned by you.",
            step3Title: "You use your QR.",
            step3Body: "Redeem it at participating businesses and events.",
            step4Title: "You get recognized.",
            step4Body: "Your achievements are visible in your community.",
        },
        earn: {
            title: "What can you earn medals for?",
            subtitle: "Whatever your passion is, there are medals here for you.",
            educationTitle: "Education",
            educationBody: "Outstanding grades, attendance, extracurricular courses.",
            sportsTitle: "Sports",
            sportsBody: "Sports at municipal facilities, tournaments, active recreation.",
            socialTitle: "Social commitment",
            socialBody: "Supporting older adults, volunteering, environmental care.",
            environmentTitle: "Environment",
            environmentBody: "Recycling, cleanup events, environmental awareness.",
            artTitle: "Art and culture",
            artBody: "Municipal workshops, classes, community arts activities.",
            civicTitle: "Civic technology",
            civicBody: "Collaboration on the municipality’s social media channels and promotion of municipal programs.",
        },
        medals: {
            title: "Medals",
            subtitle: "Every month brings new challenges. Special medals are for those who go one step further.",
            laurusName: "LAURUS",
            laurusBody: "For merit and effort: culture, workshops, consistency.",
            featured: "Featured medal",
        },
        redeem: {
            title: "How do you use your medals?",
            body: "In the app, users open the Redeem section, choose a category such as dining, sports, or entertainment, browse nearby participating businesses, select a benefit, see how many medals are required, and generate a single-use QR code to present at the business. The complete redemption history is available under “My Redemptions.”",
            flow1: "Open Redeem",
            flow2: "Choose a category",
            flow3: "Pick a benefit",
            flow4: "Generate your QR",
            catsTitle: "Redemption categories",
            shows: "Shows",
            entertainment: "Entertainment",
            dining: "Dining",
            supermarkets: "Supermarkets",
            sports: "Sports",
            transportation: "Transportation",
        },
        join: {
            title: "Joining is easy",
            step1Title: "Download the app.",
            step1Body: "Google Play or App Store. It’s free.",
            step2Title: "Enter your phone number.",
            step2Body: "Area code without the leading zero + phone number.",
            step3Title: "Verify with your DNI.",
            step3Body: "The system securely verifies your identity.",
            step4Title: "Start earning!",
            step4Body: "Your first medal arrives automatically. You earn the rest.",
        },
        municipalities: {
            title: "The youth merit platform for innovative municipalities.",
            intro: "Vos Sumás is a smart public-policy platform that connects young people, institutions, and businesses.",
            b1: "Young people connected to the municipality, with a permanent presence on the device they use most.",
            b2: "Real-time strategic data for better public-policy decisions.",
            b3: "Formal public-private partnerships with businesses and institutions.",
            b4: "Improved social indicators across health, education, sports, and the environment.",
            b5: "Recognition of youth merit that is visible and valued by the community.",
            b6: "Positioning as a modern and innovative municipality.",
            cta: "Your municipality can be the next to turn merit into public policy. Contact us for a personalized presentation.",
            ctaButton: "Contact us",
        },
        company: {
            title: "Company",
            body: "Vos Sumás is a platform developed and operated by Panda Net SRL, an Argentine company based in the City of Buenos Aires. Panda Net SRL is responsible for the development, operation, and support of Vos Sumás. For commercial or institutional inquiries, contact us at administracion@vossumas.com.",
            entityType: "Entity type",
            legalName: "Legal name",
            cuit: "CUIT",
        },
        contact: {
            title: "Contact",
            intro: "Reach Panda Net SRL for commercial, institutional, or general inquiries about Vos Sumás.",
            administracionLabel: "Commercial / institutional",
            contactoLabel: "General contact",
            infoLabel: "Information",
            waitlistTitle: "Get notified when the apps launch",
            waitlistBody: "Optional. Leave your email and we will let you know when downloads are available.",
            emailPlaceholder: "votre@email.com",
            submitButton: "Prévenez-moi",
            sendingButton: "Envoi...",
            privacyNote: "We will only use your email for launch updates. You can unsubscribe anytime.",
            availableSoonTitle: "Apps available soon",
            availableSoonBody: "Store links will appear here as soon as Vos Sumás is published on Google Play and the App Store.",
        },
        form: {
            invalidEmail: "Email Invalide",
            invalidEmailDescription: "Veuillez entrer une adresse email valide.",
            thankYou: "Merci !",
            successMessage: "Message envoyé avec succès.",
            couldNotSend: "Nous n'avons pas pu envoyer votre demande",
            emailRequired: "Email requis.",
            somethingWentWrong: "Oups, quelque chose s'est mal passé",
            tryAgain: "Réessayez dans quelques secondes.",
        },
        footer: {
            legalLine: "© 2026 Panda Net SRL. All rights reserved. Vos Sumás is a brand of Panda Net SRL.",
            privacy: "Politique de confidentialité",
            terms: "Conditions générales",
            contact: "Contact",
        },
        legalPage: {
            downloadPdf: "Télécharger le PDF",
            backHome: "Retour à l'accueil",
            spanishOnlyNote: "This legal document is published in Spanish, as approved by the client.",
        },
        common: {
            close: "Fermer",
        },
    },
};
